import { CRM_WEB_PAGES_URLS } from '../CRM_WEB_PAGES_URLS';
import { PATIENT_WEB_PAGES_URLS } from '../PATIENT_WEB_PAGES_URLS';
import { usStates } from '../data';
import { defaultOrgConfig } from './default';
import { OrganizationSettings } from '@care-portals/api-interfaces';

export const rev: OrganizationSettings = defaultOrgConfig(
  'rev',
  'RevHealth',
  'revhealth.co'
);

const excludedStates = {
  WV: true,
  KS: true,
  NM: true,
  MS: true,
  LA: true,
  OTHER: true
};

rev.blockCreateOrderOnFailedPayment = true;
rev.patientWebAppLayout.availableStates.us = usStates.filter(
  ({ code }) => !excludedStates[code]
);
rev.patientWebAppLayout.nmiPublicKey = '67Rp9W-dtgTqt-W2dW6W-jRq9U6';
rev.crmWebAppLayout.logo =
  'https://framerusercontent.com/images/MBl4IldpEl82qhcmgu4Zp8Ne2Gk.svg';
rev.patientWebAppLayout.colors = { primaryColor: '#AF37A6' };
rev.patientWebAppLayout.termsOfUseUrl = 'https://www.revhealth.co/terms';
rev.patientWebAppLayout.privacyPolicyUrl = 'https://www.revhealth.co/privacy';
rev.patientWebAppLayout.mainMenu.push({
  title: 'Subscriptions',
  link: PATIENT_WEB_PAGES_URLS.subscriptions.list,
  svg: 'assets/icons/orders.svg',
  roles: ['*']
});
rev.patientWebAppLayout.logo = {
  img: 'https://framerusercontent.com/images/MBl4IldpEl82qhcmgu4Zp8Ne2Gk.svg',
  link: 'https://revhealth.co'
};

rev.crmWebAppLayout.mainMenu = [
  {
    title: 'Leads',
    link: CRM_WEB_PAGES_URLS.leads.list,
    icon: 'fa-regular fa-address-book',
    roles: ['*']
  },

  {
    title: 'Tasks',
    link: CRM_WEB_PAGES_URLS.tasks.list,
    icon: 'fa-solid fa-list-check',
    roles: ['*']
  },
  {
    title: 'Segments',
    link: CRM_WEB_PAGES_URLS.segment.list,
    icon: 'fa-solid fa-table-columns',
    roles: ['*']
  },
  {
    title: 'Store Manager',
    link: '',
    icon: 'fas fa-shop',
    roles: ['admin', 'developer', 'owner'],
    items: [
      {
        title: 'Products',
        link: CRM_WEB_PAGES_URLS.products.list,
        icon: 'fas fa-product'
      },
      {
        title: 'Categories',
        link: CRM_WEB_PAGES_URLS.productCategories.list,
        icon: 'fas fa-product'
      }
    ]
  },
  {
    title: 'Admin',
    link: '',
    icon: 'fas fa-user-cog',
    roles: ['admin', 'developer', 'owner'],
    items: [
      {
        title: 'Workflows',
        link: CRM_WEB_PAGES_URLS.workflows.list,
        icon: 'fas fa-code-branch'
      },
      {
        title: 'Templates',
        link: CRM_WEB_PAGES_URLS.emailTemplates.list,
        icon: 'fas fa-palette'
      },
      {
        title: 'Users',
        link: CRM_WEB_PAGES_URLS.users.list,
        icon: 'fas fa-lock'
      },
      {
        title: 'Settings',
        link: CRM_WEB_PAGES_URLS.settings.base,
        icon: 'fa-solid fa-sliders'
      }
    ]
  }
];

rev.pharmacies = {
  Curexa: {
    _id: '65e1ed1d8cd6e41498619bc4',
    belugaId: '29992',
    states: [
      'CA',
      'GA',
      'ID',
      'IL',
      'IA',
      'MA',
      'NE',
      'NH',
      'ND',
      'OH',
      'WA',
      'MD',
      'NV',
      'NJ',
      'NC',
      'WI',
      'AZ',
      'CO',
      'CT',
      'DE',
      'DC',
      'FL',
      'ME',
      'MN',
      'MO',
      'MT',
      'NY',
      'OK',
      'OR',
      'PA',
      'RI',
      'SD',
      'TN',
      'TX',
      'UT',
      'WY',
      'AL',
      'AK',
      'AR',
      'IN',
      'KY',
      'MI',
      'SC',
      'VT',
      'VA'
    ]
  }
};
